import { Checkbox, Stack } from "@mantine/core";
import React from "react";
import { useActions, useAppState } from "src/state";
import { Tenant_Type_Enum } from "src/state/gql/_types";
import { useCalendar } from "src/components/calendar/CalendarContext";

export const CalendarVenueFilter: React.FC<{}> = () => {

    const { itemsList, loading } = useAppState(state => state.tenants)
    const getAllItems = useActions().tenants.getAllItems
    const { venueFilter, setVenueFilter } = useCalendar()

    React.useEffect(() => {
        getAllItems({
            where: {
                type: { _neq: Tenant_Type_Enum.Agency }
            }
        })
    }, [])

    if (loading) return <span>Loading...</span>

    const allSelected = venueFilter.length === 0
    const someSelected = venueFilter.length > 0 && venueFilter.length < itemsList.length

    const handleAllVenueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (allSelected) {
            event.preventDefault()
        } else {
            setVenueFilter([])
        }
    }

    return (
        <Stack gap="xs">

            <Checkbox
                label="All Venues"
                checked={allSelected}
                indeterminate={someSelected}
                onChange={handleAllVenueChange}
            />

            <Stack gap="xs">
                {itemsList.map((user) => (
                    <Checkbox
                        key={user.id}
                        value={user.id}
                        label={user.name}
                        onChange={(event) => {
                            const checked = event.currentTarget.checked
                            if (checked) {
                                setVenueFilter(venueFilter.filter(id => id !== user.id))
                            } else {
                                if (venueFilter.length !== itemsList.length - 1) {
                                    setVenueFilter([...venueFilter, user.id])
                                }
                            }
                        }}
                        checked={allSelected ? true : !venueFilter.includes(user.id)}
                    />
                ))}
            </Stack>

        </Stack>
    )

}